import axios from "./api";
import {toast} from "react-toastify";

const TransportService = {

    async getTransportList() {
        try {
            const response = await axios.get('/transport');
            console.log('gettransportlist', response.data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport list';
        }
    },
    async updateTransport(id, data) {
        try {
            const response = await axios.put('/transport/'+ id, data);
            return response.data;
        } catch (error) {
            toast.error('Transport o‘zgartirishda xatolik, transport raqami mavjud bolishi mumkin');
            // throw error.response?.data?.message || 'Error getting transport list';
        }
    },
    async deleteTransport(id) {
        try {
            const response = await axios.delete('/transport/'+ id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error deleting transport list';
        }
    },

    /**
     * Name	Description
     * ega_id
     * integer
     * (query)
     * Filter by ega (owner) ID
     *
     * ega_id
     * tur_nomi
     * string
     * (query)
     * Filter by transport type name (partial match)
     *
     * tur_nomi
     * search
     * string
     * (query)
     * Search by davlat raqami, name or tex passport raqam
     *
     * search
     * days
     * integer
     * (query)
     * Number of days from now to filter 'gacha' date
     *
     * 0
     * per_page
     * integer
     * (query)
     * Number of results per page (for pagination)
     *
     * 10
     * page_number
     * integer
     * (query)
     * Page number for pagination
     * @returns {Promise<any>}
     */
    async getTransportListByFilters(egaId, turNomi, search, days, balance, perPage, pageNumber) {
        try {
            const response = await axios.get('/transport', {
                params: {
                    ega_id: egaId,
                    tur_nomi: turNomi,
                    search: search,
                    days: days,
                    balance: balance,
                    per_page: perPage,
                    page: pageNumber,
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport list';
        }
    },

    /**
     *
     * @param data
     * data should look like this {
     *   "tur_id": 2,
     *   "ega_id": 5,
     *   "name": "Isuzu NQR",
     *   "davlat_raqam": "01A123BC",
     *   "tex_passport_raqam": "AC1234567",
     *   "rang": "Oq",
     *   "izoh": "Yangi keltirilgan transport (ixtiyoriy)"
     * }
     * izoh and rang are optional
     * @returns {Promise<any>}
     */
    async addTransport(data) {
        try {
            const response = await axios.post('/transport', data);
            return response.data;
        } catch (error) {
            toast.error("Transport qo‘shishda xatolik, ehtimaol tex passport yoki davlat raqami mavjud bolishi mumkin");
            // throw error.response?.data?.message || 'Error getting transport list';
        }
    },

    /**
     * @returns {Promise<any>}
     * response looks like this
     * {
     *   "success": true,
     *   "data": [
     *     {
     *       "id": 1,
     *       "name": "Прицеп",
     *       "created_at": "2025-06-21T06:39:55.000000Z",
     *       "updated_at": "2025-06-21T06:39:55.000000Z"
     *     },
     *     {
     *       "id": 2,
     *       "name": "Калла",
     *       "created_at": "2025-06-21T06:39:55.000000Z",
     *       "updated_at": "2025-06-21T06:39:55.000000Z"
     *     }
     *   ],
     *   "message": "success"
     * }
     */
    async getTransportTypes() {
        try {
            const response = await axios.get('/transport_tur');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport turs';
        }
    },

    async transportShow(transportId) {
        try {
            const response = await axios.get('/transport/' + transportId);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport info';
        }
    },

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "data": {
     *     "current_page": 1,
     *     "data": [
     *       {
     *         "id": 2,
     *         "kassa_id": "1",
     *         "user_id": "1",
     *         "transport_id": 1,
     *         "summa": 15000,
     *         "izoh": "To'lov uchun kirim",
     *         "created_at": "2025-07-02 14:59:27",
     *         "updated_at": "2025-07-02 14:59:27",
     *         "user": "admin 998911157709",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": "2",
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": null,
     *         "litsenziya_id": null,
     *         "balance": 15000
     *       },
     *       {
     *         "id": 2,
     *         "kassa_id": "1",
     *         "user_id": "1",
     *         "transport_id": 1,
     *         "summa": -9000,
     *         "izoh": "100 litr benzin",
     *         "created_at": "2025-07-02 15:00:13",
     *         "updated_at": "2025-07-02 15:00:13",
     *         "user": "admin 998911157709",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": "2",
     *         "putyofka_id": null,
     *         "litsenziya_id": null,
     *         "balance": 6000
     *       },
     *       {
     *         "id": 2,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -120000,
     *         "izoh": null,
     *         "created_at": "2025-07-02 15:45:42",
     *         "updated_at": "2025-07-02 15:45:42",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": "2",
     *         "litsenziya_id": null,
     *         "balance": -114000
     *       },
     *       {
     *         "id": 1,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -12000,
     *         "izoh": null,
     *         "created_at": "2025-07-02 15:46:14",
     *         "updated_at": "2025-07-02 15:46:14",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": null,
     *         "litsenziya_id": "1",
     *         "balance": -126000
     *       },
     *       {
     *         "id": 2,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -21500,
     *         "izoh": null,
     *         "created_at": "2025-07-02 16:03:17",
     *         "updated_at": "2025-07-02 16:03:17",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": null,
     *         "litsenziya_id": "2",
     *         "balance": -147500
     *       },
     *       {
     *         "id": 3,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -19990,
     *         "izoh": null,
     *         "created_at": "2025-07-02 16:06:45",
     *         "updated_at": "2025-07-02 16:06:45",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": "3",
     *         "litsenziya_id": null,
     *         "balance": -167490
     *       },
     *       {
     *         "id": 4,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -200000,
     *         "izoh": null,
     *         "created_at": "2025-07-02 16:13:16",
     *         "updated_at": "2025-07-02 16:13:16",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": "4",
     *         "litsenziya_id": null,
     *         "balance": -367490
     *       },
     *       {
     *         "id": 5,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -60000,
     *         "izoh": null,
     *         "created_at": "2025-07-02 16:30:31",
     *         "updated_at": "2025-07-02 16:30:31",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": "5",
     *         "litsenziya_id": null,
     *         "balance": -427490
     *       },
     *       {
     *         "id": 3,
     *         "kassa_id": null,
     *         "user_id": null,
     *         "transport_id": 1,
     *         "summa": -12222,
     *         "izoh": null,
     *         "created_at": "2025-07-02 16:32:55",
     *         "updated_at": "2025-07-02 16:32:55",
     *         "user": "",
     *         "transport": "Isuzu NQR 01A123BC",
     *         "kassa_kirim_id": null,
     *         "kassa_chiqim_id": null,
     *         "putyofka_id": null,
     *         "litsenziya_id": "3",
     *         "balance": -439712
     *       }
     *     ],
     *     "first_page_url": "http://192.168.0.114:8000/api/transport/history/1?page=1",
     *     "from": 1,
     *     "last_page": 1,
     *     "last_page_url": "http://192.168.0.114:8000/api/transport/history/1?page=1",
     *     "links": [
     *       {
     *         "url": null,
     *         "label": "&laquo; Previous",
     *         "active": false
     *       },
     *       {
     *         "url": "http://192.168.0.114:8000/api/transport/history/1?page=1",
     *         "label": "1",
     *         "active": true
     *       },
     *       {
     *         "url": null,
     *         "label": "Next &raquo;",
     *         "active": false
     *       }
     *     ],
     *     "next_page_url": null,
     *     "path": "http://192.168.0.114:8000/api/transport/history/1",
     *     "per_page": 10,
     *     "prev_page_url": null,
     *     "to": 9,
     *     "total": 9
     *   },
     *   "message": "Tarix muvaffaqiyatli topildi"
     * }
     * @param transportId
     * @param page
     * @param perPage
     * @param from date
     * @param to date
     * @returns {Promise<any>}
     */
    async transportHistoryShow(transportId, page, perPage, from, to) {
        try {
            const response = await axios.get('/transport/history/' + transportId, {
                params: {
                    page: page,
                    per_page: perPage,
                    from: from,
                    to: to,
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport info';
        }
    },

}

export default TransportService;